import React, { useContext } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from 'final-form-material-ui';
import {
  Grid, Button, Typography, CircularProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import toast from 'react-hot-toast';
import FeedbacksContext from "../contexts/FeedbacksContext";
import emailjs from 'emailjs-com';
import { brand } from '../theme';

const useStyles = makeStyles((theme) => ({
  box: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(3),
    backgroundColor: brand.paper,
    borderLeft: `2px solid ${brand.accent}`,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2.5, 2),
    },
  },
  title: {
    marginBottom: theme.spacing(0.5),
  },
  intro: {
    color: theme.palette.text.secondary,
  },
}));

const onSubmit = async (values, addFeedback) => {
  try {
    const data = {
      feedbackName: values.name,
      feedback: values.testimonial,
      show: false,
    };

    addFeedback(data);

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_FEEDBACKS_TEMPLATE_ID,
      data, process.env.REACT_APP_EMAILJS_USER_ID)
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

    toast.success('Thank you for your feedback.', { duration: 4000 })
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Required';
  }
  if (!values.testimonial) {
    errors.testimonial = 'Required';
  }
  return errors;
};

export default function FeedbackForm() {
  const classes = useStyles();
  const feedbacksContext = useContext(FeedbacksContext);
  const { addFeedback } = feedbacksContext;

  return (
    <Form
      onSubmit={(values) => onSubmit(values, addFeedback)}
      validate={validate}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} noValidate className={classes.box}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5" component="h3" className={classes.title}>
                Worked with us?
              </Typography>
              <Typography variant="body2" className={classes.intro}>
                We value your business and appreciate your feedback. Let us know how we did.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                required
                name="name"
                component={TextField}
                type="text"
                label="Name or nickname"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                required
                name="testimonial"
                component={TextField}
                multiline
                minRows={3}
                label="Your review"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                type="submit"
                disabled={submitting}
                endIcon={submitting ? <CircularProgress size={18} color="inherit" /> : <ArrowForwardIcon />}
              >
                Submit review
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    />
  )
}
